import * as React from 'react';

interface Props {
    label: string;
    hideLabel?: boolean;
}

export function InputWrap(props: React.PropsWithChildren<Props>) {
    return <div style={{marginBottom: 8}}>
        {!props.hideLabel && (
            <div style={{fontSize: 12, marginBottom: 4, color: '#666'}}>{props.label}</div>
        )}
        <div>{props.children}</div>
    </div>;
}